import { AddressSchema } from '@onepercentio/rarum-types/_shared'
import {
  ProfileAddressFields,
  RarumUserProfile,
} from 'core/logic/user/user.types'

/** @deprecated Maps the address fields from user profile to object */
export function fromProfile(profile: RarumUserProfile) {
  return {
    cep: profile.personalData?.cep! || profile.personalData?.zipCode!,
    state: profile.personalData?.state!,
    city: profile.personalData?.city!,
    address: profile.personalData?.address! || profile.personalData?.street!,
    addressNumber:
      profile.personalData?.addressNumber! || profile.personalData?.number!,
    neighbourhood:
      profile.personalData?.neighbourhood! ||
      profile.personalData?.neighborhood!,
    complement: profile.personalData?.complement!,
  }
}

export function toV2(oldModel: ProfileAddressFields): AddressSchema {
  return {
    city: oldModel.city,
    complement: oldModel.complement,
    country: 'BR',
    neighborhood: oldModel.neighbourhood,
    number: oldModel.addressNumber,
    state: oldModel.state,
    street: oldModel.address,
    zipCode: oldModel.cep,
  }
}
